<!--库存余额拆分表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form
        ref="searchForm"
        class="inventory-balance-split-search-form"
        @search="onSearch"
        @reset="resetQuery"
        :formList="formList">
        <!-- <global-select
          v-decorator="['organizationCode', { rules: [{ required: true }] }]"
          slot="organizationCode"
          :value.sync="queryParams.organizationCode"
          :dropdown-match-select-width="false"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :allow-clear="false"
          :default-active-first-option="true"
        /> -->
        <ls-select-page
          slot="snapshotBatch"
          v-decorator="['snapshotBatch']"
          placeholder="请选择"
          :datas="snapshotBatchsList">
          <template slot="select-option" slot-scope="{ items }">
            <a-select-option
              v-for="item in items"
              :key="item"
            >{{ item }}</a-select-option>
          </template>
        </ls-select-page>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvInventoryBalanceSplitExport" ref="download" />
        <a-button
          type="primary"
          :loading="loading"
          @click="handleGenerate"
          v-hasPermi="['inv:invWmsStockSnapshotFpParts:convert']"
        >触发生成报表</a-button>
        <a-button
          type="primary"
          @click="handleExport"
          v-hasPermi="['inv:invWmsStockSnapshotFpParts:export']"
        >导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
            density: true, // 传入String时 初始化默认表格密度
            fullScreen: false, // 是否需要全屏
            configKey: $TableKey.INVENTORY_BALANCE_SPLIT_LIST, // 表格方案配置唯一值
          }"
        >
          <template slot="disassemblyPath" slot-scope="{ record }">
            {{ record.onhandQty }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import {
  apiGetInvInventoryBalanceSplitList,
  apiInvInventoryBalanceSplitExport,
  apiInvInventoryBalanceSplitGenerate,
  apiGetSnapshotBatchs
} from '@/api/report/inventory-balance-split.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import { generateLsTableResData } from '@/utils/util.js';
import cacheSearch from '@/mixins/cacheSearch'
import cloneDeep from 'lodash.clonedeep'
import { mapState } from 'vuex'

export default {
  // eslint-disable-next-line
  name: 'InventoryBalanceSplit', // name要和rms配置菜单路由保存一致(首字母大写)
  mixins: [cacheSearch],
  components: { DownloadModal },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  data () {
    return {
      apiInvInventoryBalanceSplitExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetInvInventoryBalanceSplitList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      loading: false,
      snapshotBatchsInit: null,
      snapshotBatchsList: [],
      // 查询参数
      queryParams: {
        tenantId: undefined,
        invlocationName: undefined,
        skuKey: undefined,
        partSkuKey: undefined,
        wipEntityName: undefined,
        orderNo: undefined,
        snapshotBatch: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '子库编码',
          decorator: ['tenantId'],
          type: 'input'
        },
        {
          label: '子库名称',
          decorator: ['invlocationName'],
          type: 'input'
        },
        {
          label: '物料编码',
          decorator: ['skuKey'],
          type: 'input'
        },
        {
          label: '拆解后的物料编码',
          labelCol: { style: 'width: 150px' },
          decorator: ['partSkuKey'],
          type: 'input'
        },
        {
          label: '工单号',
          decorator: ['wipEntityName'],
          type: 'input'
        },
        {
          label: '计划单号',
          decorator: ['orderNo'],
          type: 'input'
        },
        {
          label: '版本号',
          decorator: ['snapshotBatch'],
          type: 'snapshotBatch'
        }
      ],
      // 表格字段
      columns: [
        {
          title: '子库编码',
          dataIndex: 'tenantId',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '子库名称',
          dataIndex: 'invlocationName',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'skuKey',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'skuName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specModel',
          align: 'center',
          width: 500,
          ellipsis: true
        },
        {
          title: '拆解后的物料编码',
          dataIndex: 'partSkuKey',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '拆解后的物料名称',
          dataIndex: 'partSkuName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'unit',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划单号',
          dataIndex: 'orderNo',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '生产批次号',
          dataIndex: 'lotName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '版本号',
          dataIndex: 'snapshotBatch',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '现有量',
          dataIndex: 'onhandQty',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '拆解后零部件数',
          dataIndex: 'disassemblyPath',
          scopedSlots: { customRender: 'disassemblyPath' },
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  created () {
    this.getSnapshotBatchs()
  },
  mounted () {
  },
  methods: {
    getSnapshotBatchs() {
      apiGetSnapshotBatchs({ pageSize: 9999 }).then((res) => {
        if(res.code === 200) {
          this.snapshotBatchsList = res.rows
          if (!this.queryParams?.snapshotBatch) {
            this.$refs.searchForm.form.setFieldsValue({ snapshotBatch: res.rows[0] || "" })
          }
          this.$refs.searchForm.handleSearch()
        }
      })
    },
    // 表单搜索
    onSearch (value = {}) {
      const params = Object.assign({}, cloneDeep(this.queryParams), value)
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = cloneDeep(params);
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch(this.$refs.dataTable.searchParams)
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        tenantId: undefined,
        invlocationName: undefined,
        skuKey: undefined,
        partSkuKey: undefined,
        wipEntityName: undefined,
        orderNo: undefined,
        snapshotBatch: undefined
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleGenerate() {
      this.loading = true;
      apiInvInventoryBalanceSplitGenerate({}).then(res => {
        if (res?.code === 200) {
          this.$message.success('触发生成报表成功')
          this.handleOk(true)
        } else {
          this.$message.error(res?.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 导出
    handleExport() {
      const params = cloneDeep(this.$refs.dataTable.searchParams)
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
/deep/.inventory-balance-split-search-form .ant-col:nth-child(4) {
  .ant-form-item{
    .ant-form-item-label{
      width: 150px !important;
    }
    .ant-form-item-control-wrapper{
      max-width: 240px !important;
    }
  }
}
</style>
